import React from "react";
import { useSelector } from "react-redux";
import { Room } from "twilio-video";
import { RootState } from "store/reducers";
import { RemoteParticipant } from "../remote-participant/RemoteParticipant";
import styles from "./GridLayout.module.css";
import { useParticipantsInAreaFilter } from "hooks/useParticipantsInAreaFilter";
import { useInteractivityListeners } from "hooks/useInteractivityListeners";
import { LocalParticipant } from "../local-participant/LocalParticipant";
import { ParticipantsList } from "../participants-list/ParticipantsList";
import { Chat } from "../chat/Chat";

interface GridLayoutProps {
  room: Room;
  participantsInArea: string[];
}
export const GridLayout: React.FC<GridLayoutProps> = ({
  room,
  participantsInArea,
}) => {
  const { participants } = useSelector((s: RootState) => s.remoteParticipants);
  const { privateChatEnabled } = useSelector((s: RootState) => s.user);
  const { participantsInAreaFilter } = useParticipantsInAreaFilter(
    participantsInArea
  );

  useInteractivityListeners(styles["local-participant-container"]);
  useInteractivityListeners(styles["remote-participants-grid"]);

  return (
    <>
      <div className={styles["local-participant-container"]}>
        <LocalParticipant
          key={room.localParticipant.sid + "-local-participant"}
          participant={room.localParticipant}
          inSidebar={false}
        />
      </div>
      <div className={`${styles["remote-participants-grid"]}`}>
        {participants
          .filter(participantsInAreaFilter)
          .filter((p) => p.videoIsEnabled && !p.isSwitchedOff)
          .map((p) => {
            const participant = room.participants.get(p.sid);
            if (participant) {
              return (
                <RemoteParticipant
                  key={participant.sid}
                  participant={participant}
                  participantState={p}
                  participantsCount={
                    participants
                      .filter(participantsInAreaFilter)
                      .filter(
                        (p) => p.videoIsEnabled && p.isSwitchedOff === false
                      ).length
                  }
                />
              );
            }
            return null;
          })}
        {participants.filter(participantsInAreaFilter).length === 0 && (
          <div className={styles["waiting-message-container"]}>
            <div className={styles["waiting-message-dialog"]}>
              <p className="lead text-center mb-0">
                Waiting for others to join...
              </p>
            </div>
          </div>
        )}
      </div>
      {participants.filter(participantsInAreaFilter).length && (
        <ParticipantsList
          room={room}
          participants={participants}
          participantsInArea={participantsInArea}
        />
      )}
      {privateChatEnabled && <Chat />}
    </>
  );
};
